
(() => {
  const CODE = "COMMUNITY12";
  const GIFT_VARIANT_ID = 59965445407104;
  const GIFT_MARKER = "_k12_community_gift";

  // Produktnamen entsprechend eurer Shopify-Rabattregel.
  const ELIGIBLE_PRODUCTS = new Set([
    "Aufbau Shake Schokolade",
    "Aufbau Shake Erdbeere",
    "Aufbau Shake Cappuccino"
  ]);

  const root = window.Shopify?.routes?.root || "/";
  let busy = false;
  let checking = false;

  async function getCart() {
    const response = await fetch(`${root}cart.js`, {
      cache: "no-store"
    });
    if (!response.ok) throw new Error("Warenkorb konnte nicht geladen werden.");
    return response.json();
  }

  async function postCart(endpoint, data) {
    const response = await fetch(`${root}cart/${endpoint}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`Shopify-Fehler bei ${endpoint}`);
    }

    return response.json();
  }

  function qualifies(cart) {
    return cart.items.some(item =>
      ELIGIBLE_PRODUCTS.has(item.product_title)
    );
  }

  function giftItems(cart) {
    return cart.items.filter(item =>
      Number(item.variant_id) === GIFT_VARIANT_ID
    );
  }

  function automaticGifts(cart) {
    return giftItems(cart).filter(item =>
      item.properties?.[GIFT_MARKER] === "1"
    );
  }

  function codeIsActive(cart) {
    return (cart.discount_codes || []).some(discount =>
      discount.code?.toUpperCase() === CODE && discount.applicable
    );
  }

  function giftIsFree(cart) {
    return giftItems(cart).some(item =>
      item.quantity === 1 && item.final_line_price === 0
    );
  }

  function otherActiveCodes(cart) {
    return (cart.discount_codes || [])
      .filter(discount =>
        discount.applicable &&
        discount.code?.toUpperCase() !== CODE
      )
      .map(discount => discount.code);
  }

  async function removeAutomaticGifts(cart) {
    for (const item of automaticGifts(cart)) {
      await postCart("change", {
        id: item.key,
        quantity: 0
      });
    }
  }

  function refreshCart() {
    if (window.themeVariables?.settings?.pageType === "cart") {
      window.location.reload();
    } else {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true })
      );
    }
  }

  function showError(message) {
    window.alert(message);
  }

  // Das vorhandene Rabattfeld nur bei COMMUNITY12 abfangen.
  document.addEventListener("change", async event => {
    const input = event.target;

    if (
      !(input instanceof HTMLInputElement) ||
      input.type === "hidden" ||
      !input.closest("cart-discount-field") ||
      input.value.trim().toUpperCase() !== CODE
    ) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (busy) return;

    busy = true;
    input.disabled = true;

    let giftAddedByUs = false;
    let previousCodes = [];

    try {
      let cart = await getCart();

      if (!qualifies(cart)) {
        showError(
          "Für COMMUNITY12 benötigst du mindestens einen K12 Aufbaushake im Warenkorb."
        );
        return;
      }

      previousCodes = otherActiveCodes(cart);

      // Keine zweite Probe hinzufügen, wenn bereits eine vorhanden ist.
      if (giftItems(cart).length === 0) {
        await postCart("add", {
          items: [{
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: {
              [GIFT_MARKER]: "1"
            }
          }]
        });

        giftAddedByUs = true;
      }

      // Erst jetzt den Rabatt anwenden, da beide Artikel im
      // Warenkorb liegen müssen.
      await postCart("update", {
        discount: [...previousCodes, CODE].join(",")
      });

      cart = await getCart();

      if (
        !qualifies(cart) ||
        !codeIsActive(cart) ||
        !giftIsFree(cart)
      ) {
        // Rabatt nicht erfolgreich: vorherige Codes wiederherstellen.
        await postCart("update", {
          discount: previousCodes.join(",")
        });

        if (giftAddedByUs) {
          await removeAutomaticGifts(await getCart());
        }

        showError(
          "COMMUNITY12 konnte nicht angewendet werden. Bitte prüfe, ob der Code für dich gültig ist. Es wurde keine kostenpflichtige Probe automatisch hinzugefügt."
        );

        refreshCart();
        return;
      }

      refreshCart();
    } catch (error) {
      console.error("K12 Community Gift:", error);

      try {
        await postCart("update", {
          discount: previousCodes.join(",")
        });

        if (giftAddedByUs) {
          await removeAutomaticGifts(await getCart());
        }

        refreshCart();
      } catch (cleanupError) {
        console.error("K12 Gift Cleanup:", cleanupError);
      }

      showError(
        "Die Gratisprobe konnte nicht sicher hinzugefügt werden. Bitte überprüfe deinen Warenkorb vor dem Bezahlen."
      );
    } finally {
      busy = false;
      input.disabled = false;
    }
  }, true);

  // Wenn Code oder Aufbaushake entfernt werden, eine automatisch
  // hinzugefügte, nicht mehr kostenlose Probe wieder entfernen.
  async function checkAutomaticGift() {
    if (busy || checking) return;

    checking = true;

    try {
      const cart = await getCart();
      const gifts = automaticGifts(cart);

      if (
        gifts.length > 0 &&
        (
          !qualifies(cart) ||
          !codeIsActive(cart) ||
          !giftIsFree(cart) ||
          gifts.some(item => item.quantity !== 1)
        )
      ) {
        await removeAutomaticGifts(cart);
        refreshCart();
      }
    } catch (error) {
      console.error("K12 Gift Check:", error);
    } finally {
      checking = false;
    }
  }

  document.addEventListener("cart:change", checkAutomaticGift);
  document.addEventListener("cart:refresh", checkAutomaticGift);

  // Auch nach einem erneuten Seitenaufruf prüfen.
  checkAutomaticGift();
})();